import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { PageHero } from '@/components/shared/PageHero';
import { SectionHeader } from '@/components/shared/SectionHeader';
import { EMERGENCY_CONTACTS } from '@/data/mockData';
import {
  Phone, Shield, Flame, HeartPulse, Siren, Building2, Zap, Droplet, AlertTriangle,
} from 'lucide-react';

const TYPE_ICONS = {
  barangay: Shield,
  police: Shield,
  fire: Flame,
  medical: HeartPulse,
  health: HeartPulse,
  disaster: Siren,
  utility: Zap,
  national: AlertTriangle,
};

const TYPE_TONES = {
  barangay: 'bg-primary/10 text-primary',
  police: 'bg-info/10 text-info',
  fire: 'bg-destructive/10 text-destructive',
  medical: 'bg-rose-500/10 text-rose-600',
  health: 'bg-emerald-500/10 text-emerald-600',
  disaster: 'bg-orange-500/10 text-orange-600',
  utility: 'bg-violet-500/10 text-violet-600',
  national: 'bg-amber-500/10 text-amber-600',
};

const EmergencyContacts = () => {
  return (
    <div data-testid="emergency-contacts-page">
      <PageHero
        eyebrow="Emergency"
        title="Emergency Hotlines"
        subtitle="Save these numbers. Tap to call. In a critical emergency, dial 911."
        breadcrumbs={[{ label: 'Emergency Contacts' }]}
        className="bg-gradient-to-br from-rose-700 via-rose-600 to-orange-500"
      />

      <section className="container-app section-padding">
        <SectionHeader eyebrow="Quick dial" title="All numbers" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {EMERGENCY_CONTACTS.map((c) => {
            const Icon = TYPE_ICONS[c.type] || Building2;
            const tone = TYPE_TONES[c.type] || 'bg-secondary text-muted-foreground';
            return (
              <Card key={c.label} className="p-5 card-elevated border-0" data-testid={`emergency-${c.type}`}>
                <div className="flex items-start justify-between gap-3">
                  <div className={`inline-flex h-11 w-11 items-center justify-center rounded-xl ${tone}`}>
                    <Icon className="h-5 w-5" />
                  </div>
                  <Badge variant="outline" className="text-[10px] uppercase tracking-widest">{c.type}</Badge>
                </div>
                <h3 className="mt-4 font-heading font-semibold">{c.label}</h3>
                <p className="text-xs text-muted-foreground mt-0.5">{c.description}</p>
                <a href={`tel:${c.number}`} className="mt-4 block">
                  <Button className="w-full bg-gradient-primary text-primary-foreground" data-testid={`call-${c.number.replace(/\D/g, '')}`}>
                    <Phone className="mr-2 h-4 w-4" /> {c.number}
                  </Button>
                </a>
              </Card>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default EmergencyContacts;
